import { GroupManager } from "../groupManager/GroupManager.js";
import { AppGroupSharing } from "./AppGroupSharing.js";
export class GroupSharing {
    constructor(gudhub, req, pipeService) {
      this.req = req;
      this.gudhub = gudhub;
      this.pipeService = pipeService;
      this.groupManager = new GroupManager(gudhub, req);
      this.appGroupSharing = new AppGroupSharing(gudhub, req);
    }

    createGroup(groupName) {
      return this.groupManager.createGroupApi(groupName);
    }

    updateGroup(groupId, groupName) {
      return this.groupManager.updateGroupApi(groupId, groupName);
    }

    deleteGroup(groupId) {
      return this.groupManager.deleteGroupApi(groupId);
    }

    async addUserToGroup(userId, groupId, permission) {
      let newUser = await  this.groupManager.addUserToGroupApi(userId, groupId, permission);
      this.pipeService.emit("group_members_add", { app_id: "group_sharing"}, newUser);
      return newUser;
    }

    getUsersByGroup(groupId) {
      return this.groupManager.getUsersByGroupApi(groupId);
    }

    async updateUserInGroup(userId, groupId, permission) {
      let updatedUser = await this.groupManager.updateUserInGroupApi(userId, groupId, permission);
      this.pipeService.emit("group_members_update", { app_id: "group_sharing"}, updatedUser);
      return updatedUser;
    }

    async deleteUserFromGroup(userId, groupId) {
      let deletedUser = await this.groupManager.deleteUserFromGroupApi(userId, groupId);
      this.pipeService.emit("group_members_delete", { app_id: "group_sharing"}, deletedUser);
      return deletedUser;
    }

    getGroupsByUser(userId) {
      return this.groupManager.getGroupsByUserApi(userId);
    }

    addAppToGroup(appId, groupId, permission) {
      return this.appGroupSharing.addAppToGroupApi(appId, groupId, permission);
    }

    getAppsByGroup(groupId) {
      return this.appGroupSharing.getAppsByGroupApi(groupId);
    }

    updateAppInGroup(appId, groupId, permission) {
      return this.appGroupSharing.updateAppInGroupApi(appId, groupId, permission);
    }

    deleteAppFromGroup(appId, groupId, permission) {
      return this.appGroupSharing.deleteAppFromGroupApi(appId, groupId, permission);
    }

    getGroupsByApp(appId) {
      return this.appGroupSharing.getGroupsByAppApi(appId);
    }

  }
  